<template>
    <!-- 申报 审核通过和提交成功和审核通过 -->
    <div class="page" >
        <van-nav-bar
            title=""
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
        />

        <div class="header" >
            <div class="headerSon" v-show="dataList.id">
                <div class="ok">
                    <img v-show="this.auditStatus != 2" class="ok-img" src="../../assets/images/success@2x.png" alt="">
                    <img v-show="this.auditStatus == 2" class="ok-img" src="../../assets/images/err@2x.png" alt="">
                </div>
                <div class="tip">
                    <div v-show="this.auditStatus == 0" class="tiptext" >申报提交成功</div>
                    <div v-show="this.auditStatus == 1" class="tiptext" >申报通过</div>
                    <div v-show="this.auditStatus == 2" class="tiptext ">审报不通过</div>
                </div>
                <div class="tip2">
                    <div v-show="this.auditStatus == 0" class="tiptext2">
                        请等待工作人员审核，预计1~3个工作日
                    </div>
                    <div v-show="this.auditStatus == 1" class="tiptext2">
                        恭喜您申报通过
                    </div>
                    <div v-show="this.auditStatus == 2" class="tiptext3">
                        原因：{{dataList.auditReason}}
                    </div>
                </div>
            </div>
        </div>

    <div v-show="dataList.id">
        <div class="foot" v-show="this.auditStatus == 0 || this.auditStatus == 2">
            <div class="foot-title" >
                资料信息
            </div>
            <div class="foot-txt">
                <div class="foot-txt2 left-text" v-show="dataList.companyName">
                    <div class="label-text">公司名称：</div>
                    <div class="red-text">{{dataList.companyName}}</div>
                </div>
                <div class="foot-txt2 left-text" v-show="dataList.realname">
                    <div class="label-text">申报人：</div>
                    <div class="red-text">{{dataList.realname}}</div>
                </div>
                <div class="foot-txt2 left-text" v-show="dataList.mobileNumber">
                    <div class="label-text">手机号：</div>
                    <div class="red-text">{{dataList.mobileNumber}}</div>
                </div>
                <div class="foot-txt2 left-text" v-show="dataList.idcardNo">
                    <div class="label-text">身份证号：</div>
                    <div class="red-text">{{dataList.idcardNo}}</div>
                </div>
                <div class="foot-txt3 left-text" v-show="imgList.length > 0">
                    <div class="label-text">图片:</div>
                    <div class="img-list" v-if="imgList.length > 0">
                        <div class="img-box" v-for="(image, index) in imgList" :key="index">
                            <img :src="image | qiniuImageView(1, 140, 140)">
                        </div>
                    </div>
                </div>
            </div>


        <div class="commit" v-show="this.auditStatus != 1"  @click="changeform">
            <img src="../../assets/images/btn5@2x.png" alt="">
            <div class="commit-text">修改提交</div>
        </div>

        </div>
    </div>
        <van-popup v-model="showpop">内容</van-popup>

    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import {
    Popup,
    NavBar  
} from "vant";
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
export default {
    components:{
        [Popup.name]: Popup,
        [NavBar.name]: NavBar,
    },
    name: "addOk",
    mixins: [mix1],
    created(){
        // this.getImgList();
        this.getData();
    },
    data(){
        return{
            imgList:[],
            dataList:[],
            auditStatus:2, //0：待审核，1：通过，2：不通过
            auditReason: "不通过", //驳回原因
            id:"",
            showpop:false,
        }
    },
    methods:{
    onClickLeft(){
        this.$router.go(-1);
    },
    async getImgList() {
        uiShowLoading();
      const promise = this.apiGet("homepage.slideImages");

      let apiResult = null;

      try {
        apiResult = await promise;
      } catch (ex) {
        apiResult = null;
      }

      if (this.isEmpty(apiResult)) {
        return;
      }

      this.imgList = apiResult.list;
      uiHideLoading();
      // this.pagination = apiResult.pagination
      // this.isDataLoaded = true
    },
    async getData(){
        uiShowLoading();
        const promise = this.apiGet("declaration.postForm");

        let apiResult = null;

        try {
            apiResult = await promise;
        } catch (ex) {
            apiResult = null;
        }

        if (this.isEmpty(apiResult)) {
            return;
        }

        console.log("apiResult",apiResult);


        if(apiResult.obj){
            this.dataList = apiResult.obj;
            this.auditStatus = apiResult.obj.auditStatus;
            this.id = apiResult.obj.id;
        }

        if(apiResult.obj.imgs){
            this.imgList = apiResult.obj.imgs;
        }
        if(this.id != ""){}
        console.log("this.dataList:",this.dataList);
        uiHideLoading();
    },
    changeform(){
        this.$router.push('/home/application?id='+this.id);
      }
    }

}
</script>

<style lang="less">
.page{
    .header{
        margin: 20px 20px 13px 20px;
        .headerSon{
            margin: 0 auto;
            border: 1px solid #ccc;
            width: 710px;
            height: 422px;
            background: #FFFFFF;
            box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.06);
            border-radius: 15px 15px 15px 15px;
            // display: flex;tip
            // align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            .ok{
                margin-top:77px;
                display: flex;
                justify-content: center;
                align-items: center;
                .ok-img{
                    display: block;
                    width: 96px;
                    height: 96px;
                }
            }
            .tip{
                margin-top: 39px;
                display: flex;
                align-items: center;
                justify-content: center;
                .tiptext{
                    font-size: 20px;
                    color:#FD4A46;
                    font-family: PingFang SC, PingFang SC;
                }
            }
            .tip2{
                margin-top: 22px;
                display: flex;
                align-items: center;
                justify-content: center;
                .tiptext2{
                    color: #534F4F;
                }
                .tiptext3{
                    color: #F20F00;
                }
            }
        }
    }
    .foot{
        border: 1px solid #ccc;
        border-radius: 15px  15px  15px  15px;
        margin: 13px 20px 55px 20px;
        .foot-title{
            margin: 0 auto;
            width: 160px;
            height: 56px;
            color: #38251E;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            line-height: 62px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            font-size: 16px;
        }
        .foot-txt{
            margin-top: 89px;
            .left-text{
                padding-left: 36px;
            }
            .label-text{
                    width: 200px;
                    font-size: 14px;
                }
            .foot-txt2{
                display: flex;
                font-size: 16px;
                margin-bottom: 45px;
            }
            .red-text{
                color: #F20F00;
            }
            .foot-txt3{
                display: flex;
                flex-wrap: wrap;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
            }
            .img-list{
                width: 750px;
                margin-top:20px;
                display: flex;
                .img-box{
                    border: 1px solid #ccc;
                    width: 140px;
                    height: 140px;
                    margin-left: 20px;
                    img{
                        width: 140px;
                        height: 140px;
                     }
                }
            }
        }


        .commit{
        width: 640px;
        height: 88px;
        margin: 0 auto;
        margin-top: 70px;
        margin-bottom: 60px;
        position: relative;
        img{
            display: block;
            width: 640px;
            height: 88px;
            // position: relative;
        }
        .commit-text{
           font-size: 16px;
            color: #FFFFFF;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            z-index: 999;
        }
    }



    }
    
}
</style>